import React from 'react';

import styled from 'styled-components';

import { getLayoutStyle } from 'styles/components/getLayoutStyle';
import { getPositionStyle } from 'styles/components/getPositionStyle';
import { typography } from 'styles/token/typography';

/**
 * @desc 아이템 정렬용 컴포넌트
 * 주어진 위치(position) 스타일에 따라 자식 요소들을 정렬합니다.
 *
 * @param {string} className - 추가 스타일 클래스
 * @param {React.ReactNode} children - 내부에 렌더링할 요소
 * @param {string} position - 정렬 방향 ('left', 'center', 'right' 등)
 * @param {object} style - 추가된 스타일
 * @returns {JSX.Element} 렌더링된 ItemPosition 컴포넌트
 */
const ItemPosition = ({ className, children, position, layout, style }) => {
  return (
    <PositionStyle
      className={className}
      position={position}
      style={style}
      layout={layout}
    >
      {children}
    </PositionStyle>
  );
};

const PositionStyle = styled.div`
  display: flex;
  align-items: center;

  ${({ position }) => getPositionStyle(position)}
  ${({ layout }) => getLayoutStyle(layout)}
`;

const ServiceItemPosition = styled(ItemPosition)`
  width: 100%;
  margin-top: 24px;

  & > span {
    width: 100%;
    margin-top: 8px;
    text-align: center;
    color: ${({ theme }) => theme.color.gray500};
    ${typography.bodyExtraSmall}
  }
`;
const ResultItemPosition = styled(ItemPosition)`
  width: 100%;
  margin: 0 0 16px;
  justify-content: space-between;

  @media screen and (max-width: 768px) {
    align-items: flex-start;
    flex-direction: column-reverse;
    gap: 24px;
    margin: 24px 0 12px;
  }
`;
const ResultItemAction = styled(ItemPosition)`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  margin-top: 24px;
`;

const MapResultItemPosition = styled(ItemPosition)`
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
`;

ItemPosition.Service = ServiceItemPosition;
ItemPosition.Result = ResultItemPosition;
ItemPosition.Action = ResultItemAction;
ItemPosition.MapResult = MapResultItemPosition;

export default ItemPosition;
